import React from 'react'

function Banner() {
  return (
    <div className='cv_banner'>
            <h2>AI-<span>Powered</span> CV Review</h2>
           <p> Upload your CV and let <span>EdFura AI</span> analyze it instantly. Get a personalized score, detailed feedback,<br/> and tips to boost your chances for jobs and scholarships.</p>
    </div>
  )
}

export default Banner